import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e08b970"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "responsive-table" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_8 = { class: "ion-text-center" }
const _hoisted_9 = { class: "ion-text-center" }
const _hoisted_10 = { class: "ion-text-center" }
const _hoisted_11 = { class: "ion-text-center" }
const _hoisted_12 = { class: "ion-justify-content-evenly ion-hide-sm-down" }
const _hoisted_13 = { class: "ion-hide-sm-down" }
const _hoisted_14 = { class: "ion-hide-sm-down" }
const _hoisted_15 = { class: "ion-hide-sm-down" }
const _hoisted_16 = { class: "ion-hide-sm-up" }
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createBlock(_component_BaseLayout, null, {
    title: _withCtx(() => [
      (_ctx.userInfo && _ctx.userInfo.user_type == 'member')
        ? (_openBlock(), _createBlock(_component_ion_title, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Crops')), 1)
            ]),
            _: 1
          }))
        : (_ctx.company)
          ? (_openBlock(), _createBlock(_component_ion_title, { key: 1 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Company')) + " " + _toDisplayString(_ctx.company.name) + " - " + _toDisplayString(_ctx.$t('CetaMarge')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
    ]),
    content: _withCtx(() => [
      (!_ctx.dataLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ion_spinner),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('LoadingData')), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.campaigns)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_ion_grid, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              (_ctx.userType == 'member')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_ion_button, {
                                      href: `/exploitation/${_ctx.slug}/`,
                                      color: "light"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('BackToDashboard')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["href"])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_ion_button, {
                                      href: "/",
                                      color: "light"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('BackToDashboard')), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_ion_button, {
                                      href: `/exploitation/${_ctx.slug}/`,
                                      color: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('ExploitationData')), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["href"])
                                  ]))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('MyCampaigns')), 1),
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("table", null, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Campaign')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('Status')), 1),
                                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('CompletionLevel')), 1),
                                    _hoisted_7
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaigns, (campaign, index) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                        _createElementVNode("td", _hoisted_8, [
                                          _createVNode(_component_router_link, {
                                            to: `/exploitation/${_ctx.slug}/cultures/${campaign.year}/saisie/`
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(campaign.label), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ]),
                                        _createElementVNode("td", _hoisted_9, _toDisplayString(campaign.progressStatus), 1),
                                        _createElementVNode("td", _hoisted_10, _toDisplayString(campaign.progress) + " %", 1),
                                        _createElementVNode("td", _hoisted_11, [
                                          _createElementVNode("div", _hoisted_12, [
                                            (_ctx.canUpdate(campaign))
                                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                                  key: 0,
                                                  href: `/exploitation/${_ctx.slug}/cultures/${campaign.year}/saisie/`
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      slot: "start",
                                                      icon: _ctx.createOutline
                                                    }, null, 8, ["icon"]),
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('EditCampaign')), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["href"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ion_button, {
                                              color: "secondary",
                                              href: `/exploitation/${_ctx.slug}/cultures/${campaign.year}`
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, {
                                                  slot: "start",
                                                  icon: _ctx.eyeOutline
                                                }, null, 8, ["icon"]),
                                                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('SeeCampaignData')), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["href"]),
                                            (_ctx.canValidate(campaign))
                                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                                  key: 1,
                                                  color: "tertiary",
                                                  onClick: ($event: any) => (_ctx.validateCampaign(campaign))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      slot: "start",
                                                      icon: _ctx.checkmarkOutline
                                                    }, null, 8, ["icon"]),
                                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('ValidateCampaignData')), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_16, [
                                            (_ctx.canUpdate(campaign))
                                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                                  key: 0,
                                                  size: "small",
                                                  href: `/exploitation/${_ctx.slug}/cultures/${campaign.year}/saisie/`
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      size: "small",
                                                      slot: "icon-only",
                                                      icon: _ctx.createOutline
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["href"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ion_button, {
                                              size: "small",
                                              color: "secondary",
                                              href: `/exploitation/${_ctx.slug}/cultures/${campaign.year}`
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_icon, {
                                                  size: "small",
                                                  slot: "icon-only",
                                                  icon: _ctx.eyeOutline
                                                }, null, 8, ["icon"])
                                              ]),
                                              _: 2
                                            }, 1032, ["href"]),
                                            (_ctx.canValidate(campaign))
                                              ? (_openBlock(), _createBlock(_component_ion_button, {
                                                  key: 1,
                                                  color: "tertiary",
                                                  onClick: ($event: any) => (_ctx.validateCampaign(campaign))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      size: "small",
                                                      slot: "icon-only",
                                                      icon: _ctx.checkmarkOutline
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, " Error "))
          ]))
    ]),
    _: 1
  }))
}